export enum IntegrationType {
    Unspecified = 0,
    Fortnox = 1,
    PingPayments = 2
}